import React, { Component } from 'react';
import { Radio } from 'antd';
import cx from 'classnames';
import './RadioGroup.scss';

class CustomRadioGroup extends Component {
  render() {
    const { className, list, onChange, direction = 'horizontal', ...res } = this.props;

    return (
      <Radio.Group
        className={cx('amondz-radio-group', className)}
        onChange={(e) => onChange && onChange(e.target.value)}
        {...res}
      >
        {list.map((data) => {
          return (
            <Radio
              className={direction === 'vertical' ? 'radio-vertical' : undefined}
              key={data.id}
              value={data.id}
              disabled={!!data.disabled}
            >
              {data.name}
            </Radio>
          );
        })}
      </Radio.Group>
    );
  }
}

export default CustomRadioGroup;
